/**
 * Copy-to-clipboard for [data-copy] buttons.
 *
 * <button data-copy="CHADA-XXXX-...">Copy</button>
 * or <button data-copy-target="#selector">Copy</button> to copy an
 * element's text. The label flips to "Copied ✓" for a moment.
 */
export function initCopyButtons() {
	document.addEventListener('click', async (e) => {
		const btn = e.target.closest('[data-copy], [data-copy-target]');
		if (!btn) return;

		let text = btn.getAttribute('data-copy');
		const targetSel = btn.getAttribute('data-copy-target');
		if (!text && targetSel) {
			const el = document.querySelector(targetSel);
			text = el ? el.textContent.trim() : '';
		}
		if (!text) return;

		if (await copyText(text)) {
			const original = btn.textContent;
			btn.textContent = 'Copied ✓';
			btn.classList.add('copied');
			setTimeout(() => {
				btn.textContent = original;
				btn.classList.remove('copied');
			}, 1600);
		}
	});
}

/**
 * Copy text to the clipboard. Prefers the async Clipboard API (needs a
 * secure context — https or localhost) and falls back to a hidden-textarea
 * execCommand for plain-http pages. Returns whether the copy succeeded.
 *
 * @param {string} text Text to copy.
 * @returns {Promise<boolean>}
 */
async function copyText(text) {
	if (navigator.clipboard && window.isSecureContext) {
		try {
			await navigator.clipboard.writeText(text);
			return true;
		} catch {
			/* fall through to the legacy path */
		}
	}

	try {
		const ta = document.createElement('textarea');
		ta.value = text;
		ta.setAttribute('readonly', '');
		ta.style.position = 'fixed';
		ta.style.top = '-9999px';
		document.body.appendChild(ta);
		ta.select();
		const ok = document.execCommand('copy');
		document.body.removeChild(ta);
		return ok;
	} catch {
		return false;
	}
}
